module.exports = __webpack_public_path__ + "static/media/vay-nen.da9fb8e3.jpg";